import { ExceptionCorrectionModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';
import { ExceptionCorrectionItem } from './exception-correction-item.entity';

export class ExceptionCorrection extends DomainEntity<ExceptionCorrectionModelDto> {
    constructor(dto: ExceptionCorrectionModelDto) {
        super(dto);
        this._exceptionCorrectionItems = dto.exceptionCorrectionItems?.map(
            item => new ExceptionCorrectionItem(item)
        );
    }

    private _exceptionCorrectionItems: ExceptionCorrectionItem[] | undefined;

    public createDefault(): this {
        return new ExceptionCorrection({
            arpExceptionDetailUniqueId: '',
            comment: '',
            attachment: undefined,
            attachmentFileName: '',
            exceptionCorrectionItems: undefined,
        }) as this;
    }

    public get arpExceptionDetailUniqueId() {
        return this.dto.arpExceptionDetailUniqueId;
    }

    public get comment() {
        return this.dto.comment;
    }

    public get attachment() {
        return this.dto.attachment;
    }

    public set attachment(value: string | undefined) {
        this.dto.attachment = value;
    }

    public get attachmentFileName() {
        return this.dto.attachmentFileName ?? '';
    }

    public set attachmentFileName(value: string) {
        this.dto.attachmentFileName = value;
    }

    public get exceptionCorrectionItems() {
        return this._exceptionCorrectionItems ?? [];
    }

    public set exceptionCorrectionItems(items: ExceptionCorrectionItem[]) {
        this.dto.exceptionCorrectionItems = items.map(item => item.toDto());
        this._exceptionCorrectionItems = items;
    }

    public toDto(): ExceptionCorrectionModelDto {
        return {
            ...super.toDto(),
            exceptionCorrectionItems: this.exceptionCorrectionItems.map(item => item.toDto()),
        };
    }
}
